import { createUSeDirectBookingStrategy } from "./usedirect.js";

export default createUSeDirectBookingStrategy({
  bookingBaseUrl: "https://reserveohio.com/OhioCampWeb",
});
